import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'
import toast from 'react-hot-toast'

const isSafeInternalRedirect = (redirect) => (
  typeof redirect === 'string'
  && redirect.startsWith('/')
  && !redirect.startsWith('//')
)

function SsoSuccess() {
  const navigate = useNavigate()
  const exchangeSso = useAuthStore((state) => state.exchangeSso)
  const hasStarted = useRef(false)

  useEffect(() => {
    if (hasStarted.current) return
    hasStarted.current = true

    const finishLogin = async () => {
      const result = await exchangeSso()
      if (result.success) {
        toast.success('Đăng nhập SSO thành công!')
        navigate(isSafeInternalRedirect(result.redirect) ? result.redirect : '/admin', { replace: true })
        return
      }
      navigate('/login?error=sso_exchange_failed', { replace: true })
    }

    finishLogin()
  }, [exchangeSso, navigate])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-600 to-primary-800 px-4">
      <div className="rounded-lg bg-white px-8 py-6 text-center shadow-xl">
        <div className="mx-auto mb-4 h-10 w-10 animate-spin rounded-full border-4 border-primary-100 border-t-primary-600" />
        <p className="font-medium text-gray-800">Đang hoàn tất đăng nhập SSO...</p>
      </div>
    </div>
  )
}

export default SsoSuccess
